import React from 'react';
import { withStateHandlers, lifecycle, compose } from 'recompose';
import styled, { StylesProps } from '../../../lib/styles';
import meetupPanelStyles from './MeetupsBlock_styles';
import { Meetup } from '../../../models/collection';
import Spacer from '../../../components/presentational/Spacer';
import Typography from '../../../components/presentational/Typography';
import Button from '../../../components/presentational/Button';

import { trackEvent } from '../../../lib/ga';
import { FIND_MEETUPS } from '../lib/ga';
import Image from '../../../components/presentational/Image';
import { Brand } from '../../../lib/theme';

export interface MeetupsBlockProps {
  meetups: Meetup[];
  brand: Brand;
}

const MeetupsBlock = ({
  meetups,
  styles,
  brand,
}: MeetupsBlockProps & StylesProps<typeof meetupPanelStyles>) => (
  <div className={styles.container}>
    <Spacer width={1160} space={'m'} align={'center'}>
      <Spacer width={560} space={'m'}>
        <Typography>
          <h1>
            Meet likeminded{brand === 'tas' ? ' Travel Buddies' : ' over-60s'}
          </h1>
        </Typography>

        <Typography weight={'normal'}>
          <h4>
            The Starts at 60 Club hosts 90+ meet-ups every month all over
            Australia &amp; New Zealand.
          </h4>
        </Typography>

        <Typography weight={'normal'}>
          <h4>
            They are a perfect low-pressure way to meet likeminded over-60s in
            your local community over a chat and a cuppa!
          </h4>
        </Typography>

        <Button
          color={'light_grey'}
          href={'//club.startsat60.com/meetups'}
          onClick={() => trackEvent(FIND_MEETUPS)}
        >
          Find a meet-up near me
        </Button>
      </Spacer>

      <div className={styles.meetups}>
        {meetups.map(({ imageURL, location }, i: number) => (
          <Image
            lazy
            key={`${location}_${i}`}
            alt={`Meetup image: ${location}`}
            className={styles.meetup}
            src={imageURL}
            width={160}
            height={160}
            aspect={[1, 1]}
            resizeWidth={160}
            resizeFit={'min'}
          />
        ))}
      </div>
    </Spacer>
  </div>
);

export default compose(
  withStateHandlers(
    ({ meetups }) => ({
      meetups,
    }),
    {
      shuffle: ({ meetups }) => () => {
        const showcased = meetups.sort(() => 0.5 - Math.random()).slice(0, 6);
        return {
          meetups: [...showcased],
        };
      },
    }
  ),
  lifecycle({
    componentDidMount() {
      (this.props as any).shuffle();
    },
  }),
  styled(meetupPanelStyles)
)(MeetupsBlock);
